<template>
  <div class="item-style">
    <div class="box">
      <span class="cx-search-icon cx-clickable-icon mx-2"
            @click="handleClick">
        <i class="fas fa-search"></i>
      </span>
    </div>
    <div class="box">
      <img  :src="src" 
            class="retailer-cell-image" />
    </div>
    <div class="box">
      <span class="mx-2">{{ this.getData() }}</span><br/>
      <span class="mx-2">{{ this.location.PostalCode }} {{ this.location.City }}</span>
    </div>
  </div>
</template>

<script>
export default {
  beforeMount() {
    const regex = /___(\d+)$/;
    const match = this.params.value.match(regex);
    this.number = match ? match[1] : null;
    this.location = this.params.context.getLocation(parseInt(this.number));
    this.src = this.location.HasLogo
      ? `${process.env.BASE_URL}api/dashboard/location-image/${this.location.ClientLocationId}`
      : this.params.context.getDefaultLogo();
  },

  methods: {
    getData() {
      return this.location?.Name;
    },

    handleClick(event) {
      this.params.context.onClickRetailer(parseInt(this.number));
    }
  }
}
</script>

<style >
  .item-style  {
    line-height: 1.5rem!important; 
    padding-top: 10px!important; 
    padding-bottom: 10px!important;
    text-align: left; 
    text-align: -webkit-left;
    font-weight: 600;
    font-size: 15px;
  }
  
  .item-style div {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .box {
    display: inline-block;
    line-height: 1.3;
    vertical-align: top;
  }

  .retailer-cell-image {
    width: 56px;
    height: 40px;
    object-fit: cover; /* Ensures the image covers the area without distortion */
  }
</style>